// matches character sequences starting with a letter and being composed of letters, quote or dash.
const WORD_REGEX = /\p{L}[\p{L}'-]*/gu;

export function countWords(text?: string) {
    return text?.match(WORD_REGEX)?.length || 0;
}
